module.exports = __webpack_public_path__ + "static/img/total@2x.5db9793.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/total@2x.png
// module id = GCSg
// module chunks = 7